/**
 * The canonical interest lifecycle state vocabulary. This `as const` tuple is the single source
 * of truth so the zod mirror in `src/context/` can build `z.enum(...)` from it and cannot drift
 * from the pure engine types.
 */
export const INTEREST_LIFECYCLE_STATES = ['new', 'open', 'closed', 'unsuccessful'] as const;
